// Mirrors ImperansCRM.Common.Enums.ClientCreationRouteEnum
export enum ClientCreationRoute {
  NewProspect = 1,
  NewClientOnboarding = 2,
  CurrentClient = 3,
}
